import { BrSelect } from '@govbr-ds/react-components';
import { useState, useEffect } from 'react';
import style from './exercicioSelect.module.scss';
import { mesParaAbreviacao } from '../../utils/mesParaAbreviacao';

interface IExercicioSelect {
  dates: number | number[];
  ano: string;
}

export const ExercicioSelect = ({ dates, ano }: IExercicioSelect) => {
  const [date, setDate] = useState(Array.isArray(dates) ? dates[0] : dates);

  useEffect(() => {
    setDate(Array.isArray(dates) ? dates[0] : dates);
    sessionStorage.setItem('mesDeclaracao', '-1');
  }, [ano]);

  const onDateChange = (value: number) => {
    setDate(value);
    sessionStorage.setItem('mesDeclaracao', value.toString());
  };

  const transformedDates = Array.isArray(dates)
    ? dates.map((date) => ({
        label: mesParaAbreviacao(date),
        value: date,
      }))
    : [{ label: mesParaAbreviacao(date), value: dates }];

  console.log(transformedDates);

  return (
    <>
      {transformedDates.length > 0 ? (
        <BrSelect
          className={style.select}
          value={date}
          onChange={(value: number) => onDateChange(value)}
          options={transformedDates}
          placeholder='Selecione uma opção'
        />
      ) : (
        <div className={style.text}>Nenhum mês disponível</div>
      )}
    </>
  );
};
